import { render, staticRenderFns } from "./addrstaff.vue?vue&type=template&id=3853b22c&scoped=true&"
import script from "./addrstaff.vue?vue&type=script&lang=js&"
export * from "./addrstaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3853b22c",
  null
  
)

export default component.exports